<template>
  <div class="service-container">
    <!--服务进度抬头-->
    <div
      class="service-process"
      v-show="processType !== 0"
      zz-sortid="-1" zz-sortname="服务进度"
      @click="goToProcessDetail"
    >
      <div class="left">
        <span class="process-title">{{tipName}}</span>
        <span class="process-tag">{{statusDesc}}</span>
      </div>
      <div v-if="showTicketCount" class="about-tickets">
        <div class="about-num">{{ ticketCount }}</div>
        <z-icon class-prefix="zziconfont" name="arrow-right" class="link-icon"/>
      </div>
    </div>
    <slot></slot>
    <!--服务进度step-->
    <div class="process-container" v-show="processType !== 0">
      <div class="triangle"></div>
        <div class="process-content">
          <div class="process-header">
            <span class="process-header-title">{{process.title}}</span>
            <span class="process-header-time">{{process.createTime}}</span>
          </div>
        <p class="process-desc">{{stepDesc}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Icon } from '@zz-common/zz-ui'
import { lego } from '@zz-common/lego'

const statusMap = {
  1: '处理中',
  2: '处理中',
  3: '已完成',
  4: '处理中'
}
export default {
  name: 'ServiceProcess',
  props: {
    processType: { // 标识为工单还是售后单 1工单。2售后单
      type: Number
    },
    processInfo: {
      type: Object
    },
    ticketCount: {
      type: Number
    }
  },
  computed: {
    process() {
      let obj = {}
      if (this.processType === 1) {
        obj = {
          title: this.processInfo.ticketTitle,
          createTime: this.processInfo.createTime,
          state: this.processInfo.ticketStatus,
          desc: this.processInfo.ticketDesc,
          id: this.processInfo.ticketId
        }
      } else if (this.processType === 2) {
        obj = {
          title: this.processInfo.title,
          createTime: this.processInfo.createTime,
          state: this.processInfo.state,
          desc: this.processInfo.assOrderStatus,
          id: this.processInfo.assOrderId
        }
      }
      return obj
    },
    tipName() {
      return this.processType === 1 ? '服务进度' : '售后进度'
    },
    statusDesc() {
      let desc = ''
      if (this.processType === 1) {
        desc = statusMap[this.process.state]
      } else if (this.processType === 2) {
        desc = this.process.state
      }
      return desc
    },
    stepDesc() {
      const tip = this.processType === 1 ? '服务单号：' : '售后单号：'
      return `${this.process.desc}, ${tip}${this.process.id}`
    },
    showTicketCount() {
      return this.ticketCount > 1
    }
  },
  methods: {
    goToProcessDetail() {
      let id = null
      let skipUrl = ''
      let actiontype = ''
      if (this.processType === 1) {
        id = this.processInfo.ticketId
        actiontype = 'NEWHELPCENTER_PROCESSTYPE_TICKETID'
        skipUrl = 'http://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/serviceprocess/detail/'
      } else {
        id = this.processInfo.orderId
        actiontype = 'NEWHELPCENTER_PROCESSTYPE_ORDERID'
        skipUrl = 'https://m.zhuanzhuan.com/system/ZZaftersale/?orderId='
      }
      if (!id) return
      lego.send({
        pagetype: 'ZZUP_NEWHELPCENTER',
        actiontype: `${actiontype}_CLICK`,
        backup: {
          name: id
        }
      })
      native.wrap('skipToUrl')({
        targetUrl: skipUrl + id
      })
    }
  },
  components: {
    zIcon: Icon
  }
}

</script>
<style lang="less" scoped>
  @import 'index.less';
</style>